const components = {
  eventsAsideIntro: {
    helloMessage: 'Добро пожаловать в Repay, сервис, помогающий вести финансовые расчёты с друзьями, когда вы тратите деньги вместе.',
    events: 'В данной панели отображаются все события, которые ты создал, либо в которые тебя добавили. Также здесь появляются и диалоги с другими пользователями.',
    sort: 'События можно сортировать по дате или статусу.',
    create: 'Чтобы создать новое событие, нажимай сюда.',
  },
  createEventIntro: {
    create: 'Здесь ты можешь создать новое событие и добавить в него людей. Если захочешь создать диалог, просто добавь нужного пользователя и оставь название и картинку события пустыми.',
  },
  operationPanelIntro: {
    tabs: 'Во вкладке "Операции" будут находиться все действия, совершенные в данном событии. Вкладка "Моя доля" содержит операции, созданные с твоим участием. В "Долгах" можно смотреть кому должен ты, а кто должен тебе.',
    chat: 'Все операции будут отображаться в чате.',
    create: 'В зависимости от ситуации предусмотрены различные операции.Также можно писать комментарии и обмениваться мнениями.',
    optionsPanel: 'Панель настроек помогает ориентироваться в событии, приглашать и исключать участников, создавать и удалять семьи.',
  },
  eventFamiliesIntro: {
    explanation: 'Долги в семьях учитываются как общие и рассчитываются исходя из долгов всех членов семьи.',
    notInFamily: 'Пользователи без семьи находятся внизу списка.',
    create: 'Чтобы создать семью нужно перетащить человека в поле создания. В семье должен быть как минимум один человек помимо главы семьи.',
  },
  introBtns: {
    skip: 'Пропустить',
    back: 'Назад',
    next: 'Далее',
    finish: 'Завершить',
    allClear: 'Понятно',
  },
  cardForm: {
    language: {
      short: 'Рус',
      english: 'Английский',
      russian: 'Русский',
      shortEng: 'Анг',
      shortRu: 'Рус',
    },
  },
  headerApp: {
    language: {
      short: 'Рус',
      english: 'Английский',
      russian: 'Русский',
    },
    tellAFriend: 'Рассказать другу',
    people: 'Люди',
    events: 'События',
    settings: 'Настройки',
    productTour: 'Показать подсказки',
    faq: 'Частые вопросы',
    supportService: 'Связаться с нами',
    exit: 'Выход',
  },
  eventOptions: {
    eventName: 'Название события',
    eventParticipants: 'Участники: ',
    eventUnableToDeleteUserWithDebt: 'Невозможно удалить пользователя с долгом',
    eventUnableToDeleteActiveUser: 'Невозможно удалить пользователя с историей операций',
  },
  peopleList: {
    noUsers: 'Нет пользователей',
  },
  addHumanButton: {
    addParticipants: 'Добавить участников',
  },
  eventsAside: {
    sortByUpdate: 'По дате обновления',
    sortByCreation: 'По дате создания',
    filterAll: 'Все события',
    filterByDebts: 'События с долгами',
  },
  peopleAside: {
    sortAlphabetically: 'По алфавиту',
    sortByDebtAmount: 'По сумме долга',
    filterAll: 'Все',
    filterMyDebts: 'Мои долги',
    filterMyDebtors: 'Мне должны',
  },
  searchInput: {
    placeholderSearch: 'Поиск',
  },
  eventList: {
    noEvents: 'Пока нет событий',
    noEventsFound: 'События не найдены',
  },
  humanProfile: {
    makePayments: 'Произвести выплаты',
  },
  proposedTransactions: {
    addTransaction: 'Добавить операцию',
    evenPurchase: 'покупка поровну',
    splitPurchase: 'покупка не поровну',
    iBoughtThem_M: 'я купил',
    iBoughtThem_F: 'я купила',
    theyBoughtMe: 'мне купили',
    iLentThem_M: 'я одолжил',
    iLentThem_F: 'я одолжила',
    theyLentMe: 'мне одолжили',
    deposit: 'приход',
    comment: 'комментарий',
    calendarSameDay: '[Сегодня, ] LT',
    calendarNextDay: '[Вчера, ] LT',
  },
  emptyEventOperations: {
    youDontHaveEvents: 'У Вас ещё нет ни одного события.',
    createNewEvent: 'Создайте новое событие,',
    toStartRepay: 'чтобы начать пользоваться сервисом Repay!',
    noEventsFound: 'Не нашлось событий по данному запросу',
    newEvent: 'Создать новое событие',
  },
  emptyHumanProfile: {
    youDontHaveFriends: 'Список друзей пуст.',
    addNewFriend: 'Добавьте друзей,',
    toStartEvents: 'чтобы начать создавать события с ними!',
    newFriend: 'Добавить друга',
  },
};
const commonPhrases = {
  CP: {
    me: 'Я',
    meGenitive: 'Меня',
    yes: 'Да',
    no: 'Нет',
    cancel: 'Отмена',
    add: 'Добавить',
    close: 'Закрыть',
    events: 'События',
    confirmDeleteEvent: 'Подтвердить удаление события?',
    confirmDeleteAccount: 'Это действие необратимо. \n Вы уверены, что хотите удалить аккаунт?',
    currency: 'Валюта',
    exchangeRates: 'Курсы валют',
    changeCurrency: 'Сменить валюту',
    noDebts: 'Нет долгов',
    myTurnToPay: 'Моя очередь платить',
    addUser: 'Добавить пользователя',
    ready: 'Готово',
    transactions: 'Операции',
    myShare: 'Моя доля',
    debts: 'Долги',
    amount: 'Сумма',
    totalAmount: 'Итоговая сумма',
    newTransaction: 'Новая операция',
    purpose: 'Назначение',
    whoPays: 'Кто платит',
    whoReceives: 'Кто получает',
    create: 'Создать',
    transactionParticipants: 'Участники операции',
    sender: 'Отправитель',
    recipient: 'Получатель',
    noTransactionsYet: 'Пока нет операций',
    turnToPay: 'Очередь платить',
    theyOweMe: 'Мне должны',
    iOweThem_M: 'Я должен',
    iOweThem_F: 'Я должна',
    averageExpensesPerDay: 'Средние траты в день',
    people: 'Люди',
    enterPhoneNumber: 'Введите номер телефона',
    enterNameOrPhone: 'Введите имя или номер телефона',
    userNotFound: 'Пользователь не найден',
    evenPurchase: 'Покупка поровну',
    splitPurchase: 'Покупка не поровну',
    iBoughtThem_M: 'Я купил',
    iBoughtThem_F: 'Я купила',
    theyBoughtMe: 'Мне купили',
    iLentThem_M: 'Я одолжил',
    iLentThem_F: 'Я одолжила',
    theyLentMe: 'Мне одолжили',
    deposit: 'Приход',
    payback: 'Выплата',
    comment: 'Комментарий',
    theyOwesMe_M: 'Должен мне',
    theyOwesMe_F: 'Должна мне',
    wholeFamily: 'Вся семья',
    save: 'Сохранить',
    input: 'Ввод',
    participants: 'Участники',
    transferOperation: 'Перенести операцию',
    restorePassword: 'Восстановление пароля',
    event: 'Событие',
    clone: 'Клонировать',
    eventName: 'Название события',
    eventParticipants: 'Участники события',
    confirmDeleteUser: 'Вы уверены, что хотите исключить участника?',
    confirmDeleteContact: 'Вы уверены, что хотите удалить контакт?',
    addNewParticipant: 'Хотите добавить нового участника?',
    noCancelExclude: 'Нет, не исключать',
    newOperationsMessage: 'Новые операции',
    yesDelete: 'Да, удалить',
    yesExclude: 'Да, исключить',
    settings: 'Настройки',
    name: 'Имя',
    surname: 'Фамилия',
    gender: 'Пол',
    male: 'Мужской',
    female: 'Женский',
    changePassword: 'Изменить пароль',
    newPassword: 'Новый пароль',
    oldPassword: 'Старый пароль',
    weSentCode: 'Мы выслали SMS с кодом подтверждения\n'
      + 'на Ваш номер телефона',
    sendCodeAgain: 'Выслать код еще раз',
    sendCodeTimer: 'Выслать код еще раз через ',
    sendCode: 'Отправить код',
    confirmationCode: 'Код подтверждения',
    addParticipants: 'Добавить участников',
    notFound404: '404 Не найдено',
    unfortunately404: 'К сожалению, такой страницы не существует или она находится в разработке.',
    tryContact: 'Попробуйте обратиться в ',
    supportService: 'службу поддержки.',
    confirmDeleteTransaction: 'Вы уверены, что хотите удалить операцию?',
    myFamily: 'Моя семья',
    cropAThumbnail: 'Обрезать изображение до миниатюры',
    offerRepay: 'Предлагаю попробовать Repay. Он идеально подходит, чтобы вести наши взаиморасчёты.',
    errorOutOfBoundsPictureCrop: 'Размер изображения должен быть между 70x70 и 10000x10000 пикселей',
    errorPictureCropUrlSize: 'Размер изображения слишком большой',
    firstName: 'Имя',
    lastName: 'Фамилия',
    youCanCreate: 'Вы можете создать этого пользователя',
    userAlreadyAdded: 'Пользователь уже добавлен',
    allParticipantsAdded: 'Все участники события уже добавлены в операцию',
    toAddNewUsers: 'Чтобы добавить новых участников, воспользуйтесь нижним полем поиска',
    addEvent: 'Добавить событие',
    familiesSettings: 'Настройки семей',
    changeFamily: 'Изменить семью',
    confirmDeleteFamily: 'Удаляя главу семьи, вы удалите всю семью. Удалить?',
    createFamily: 'Создать новую семью',
    confirmCreateFamily: 'Создать новую семью?',
    chooseFamilyHead: 'Выберите главу семьи',
    chooseFamilyMembers: 'Выберите участников семьи',
    confirmSaveFamilies: 'Сохранить изменения семей в событии?',
    family: 'Семья',
    notInFamily: 'Не в семье',
    newFamily: 'Новая семья',
    updated: 'Обновлено',
    toCreateQuasiEvent: 'Чтобы создать диалог с другим пользователем,',
    addUserAndDeleteImage: 'добавьте его в событие и оставьте изображение и название события пустыми',
    contactNotFound: 'Пользователь с данным номером телефона не найден,'
      + ' вы можете создать нового',
    noConvertation: 'Без конвертации',
    errorOccurred: 'Произошла ошибка, сервис временно недоступен',
    sumTotalMessage: 'Общая сумма (остаток суммы делится поровну между участниками)',
    sumTotalMessageSplitProportional: 'Общая сумма (остаток суммы делится пропорционально)',
    aTip: 'Чаевые',
    tips: 'Чаевые',
    serviceFee: 'Сервисный сбор',
    inviteUnregistered: 'Пригласить незарегистрированных пользователей',
    advancedOptions: 'Дополнительные параметры',
    fillInYourProfile: 'Заполните свой профиль',
    exit: 'Выход',
    contactAlreadyAdded: 'Контакт уже добавлен',
    contactDoesNotExist: 'Этот пользователь отсутствует в списке Контактов',
    deleteFamily: 'Удалить семью',
    quitFamily: 'Выйти из семьи',
    addNewContact: 'Добавить новый контакт',
    allowCookiesMessage: 'Мы используем cookies на нашем сайте. Пожалуйста, разрешите, чтобы продолжить.',
    allowCookiesBttn: 'Разрешить',
    declineCookiesBttn: 'Отклонить',
    cookiesPageTitle: 'Вы запретили куки',
    cookiesPageMessage: 'Пожалуйста, разрешите нам использовать куки для корректной работы сайта.',
    cookiesPageBttn: 'Разрешить и обновить страницу',
    serveErrorPageTitle: 'Упс... что-то пошло не так',
    serveErrorPageMessage: 'Сайт временно не работает. \n Пожалуйста, попробуйте снова через несколько минут.',
    serveErrorPageBttn: 'Обновить страницу',
    selectSearchNotFound: 'Не найдено...',
    currencyGroupUsed: 'Ранее используемые',
    currencyGroupOthers: 'Остальные',
    noCurrencyFound: 'Валюты не найдены',
    transactionType: 'Тип платежа',
    whoPaid: 'Кто платил',
    total: 'Итого',
    balanceBeforeTransaction: 'Баланс до операции',
    balanceAfterTransaction: 'Баланс после операции',
    peopleSeenList: 'Список прочитавших',
    proportionalRemainderSplit: 'Делить остаток пропорционально',
    uploadImage: 'Загрузите изображение',
    choosePredefinedAvatars: 'Или выберите из готовых ниже',
    gotAnyQuestions: 'У вас есть вопросы?',
    contactUs: 'Свяжитесь c нами',
    deleteAccount: 'Удалить аккаунт',
    myTotalDebt: 'Моя общая задолженность',
  },
  statusMessages: {
    iRepaidThem_M: 'Я выплатил {user}',
    iRepaidThem_F: 'Я выплатила {user}',
    theyRepaidMe_M: '{user} выплатил мне',
    theyRepaidMe_F: '{user} выплатила мне',
    theyRepaidThem_M: '{user1} выплатил {user2}',
    theyRepaidThem_F: '{user1} выплатила {user2}',
    iLentThem_M: '{user} получил от меня деньги',
    iLentThem_F: '{user} получила от меня деньги',
    theyLentMe_M: '{user} дал мне денег',
    theyLentMe_F: '{user} дала мне денег',
    theyLentThemselves_M: '{user} одолжил себе',
    theyLentThemselves_F: '{user} одолжила себе',
    iLentMyself_M: 'Платеж самому себе',
    iLentMyself_F: 'Платеж самой себе',
    theyLentThem_M: '{user1} одолжил {user2}',
    theyLentThem_F: '{user1} одолжила {user2}',
    splitFor: 'Не поровну для',
    paidBy_M: 'Оплатил',
    paidBy_F: 'Оплатила',
    iBoughtFor_M: 'Я купил для',
    iBoughtFor_F: 'Я купила для',
    theyBoughtForMe_M: '{user} купил для меня',
    theyBoughtForMe_F: '{user} купила для меня',
    theyBoughtForThemselves_M: '{user} купил себе',
    theyBoughtForThemselves_F: '{user} купила себе',
    theyBoughtForSmb_M: '{user1} купил для {user2}',
    theyBoughtForSmb_F: '{user1} купила для {user2}',
    iBoughtForMyself_M: 'Я купил себе',
    iBoughtForMyself_F: 'Я купила себе',
    evenFor: 'Поровну для',
    evenForAll: 'Поровну для всех',
    incomeFor: 'Приход для',
    incomeForAll: 'Приход для всех',
    received_M: 'Получил',
    received_F: 'Получила',
    iReceivedFor_M: 'Я получил для',
    iReceivedFor_F: 'Я получила для',
    theyReceivedForThemselves_M: '{user} получил для себя',
    theyReceivedForThemselves_F: '{user} получила для себя',
    theyReceivedForMe_M: '{user} получил для меня',
    theyReceivedForMe_F: '{user} получила для меня',
    iReceivedForMyself_M: 'Я получил для себя',
    iReceivedForMyself_F: 'Я получила для себя',
  },
};
const forms = {
  formsCommon: {
    languageInUse: 'Используемый язык',
  },
  addCommentForm: {
    placeholder: 'Введите текст',
  },
  validateText: {
    required: 'Обязательное поле',
    incorrectPhone: 'Вы ввели некорректный номер телефона.',
    shortPassword: 'Слишком короткий пароль',
    errorLoginSubmit: 'Введённая пара номер-пароль не\u00A0зарегистрирована в системе. Пожалуйста, введите номер и\u00A0пароль снова.',
    errorSignUpSubmit: 'Произошла ошибка регистрации. Пожалуйста, попытайтесь снова.',
    errorRestorePasswordSubmit: 'Не удалось сменить пароль. Пожалуйста, попытайтесь снова позже.',
    errorRestorePasswordCode: 'Не удалось выслать код. Пожалуйста, попытайтесь снова позже.',
    errorRestorePasswordCodeUserDoesntExist: 'Данного пользователя не существует.',
    errorRestorePasswordCodeTooManyRequests: 'Слишком много запросов кода на указанный номер телефона. Пожалуйста, попытайтесь снова позже.',
    errorChangePasswordSubmit: 'Вы ввели некорректный старый пароль. Пожалуйста, попытайтесь снова.',
    minimalAmount: 'Сумма должна быть не меньше',
    fillInTheFields: 'Заполните поля',
    tooShortCode: 'Слишком короткий код подтверждения',
    minAmount: 'Сумма должна быть не меньше',
    firstNameRequired: 'Имя не может быть пустым',
    lastNameRequired: 'Фамилия не может быть пустой',
    avatarRequired: 'Изображение не может быть пустым',
    phoneIncorrect: 'Неправильно набран номер телефона',
    eventNameRequired: 'Название события не может быть пустым',
    moreThanOneParticipant: 'В операции должно быть два или больше участников',
    allUsersAmountMoreThan: 'Сумма каждого участника должна быть больше',
    anyUsersBesidesPayee: 'операция должна иметь минимум одного участника, кроме того, кто платит',
    sumRemainderNotNegative: 'Остаток по общей сумме не должен быть отрицательным',
    chooseYourCurrency: 'Выберите свою валюту',
    senderRequired: 'Должен быть указан отправитель',
    recipientRequired: 'Должен быть указан получатель',
    quasiEventAlreadyExists: 'Такой диалог уже существует',
  },

  loginForm: {
    enter: 'Вход',
    description: 'Пожалуйста, введите номер телефона и пароль, чтобы войти в аккаунт',
    labelPhoneNumber: 'Номер телефона: ',
    labelPassword: 'Пароль: ',
    placeholderPhone: 'Введите номер телефона',
    placeholderPassword: 'Введите пароль',
    forgotPassword: 'Забыли пароль?',
    keepMeSignedIn: 'Оставаться в системе',
    buttonNext: 'Далее',
    haveAccount: 'У вас ещё нет аккаунта?',
    registrationLink: 'Зарегистрироваться',
    tooltip: 'Если Вы до этого пользовались только приложением\n'
      + 'в\u00A0смартфоне, пожалуйста, воспользуйтесь\n'
      + 'восстановлением пароля, чтобы войти в свой аккаунт',
  },
  signUpForm: {
    registration: 'Регистрация',
    description: 'Пожалуйста, введите номер телефона и пароль, чтобы создать аккаунт',
    labelPhoneNumber: 'Номер телефона: ',
    labelPassword: 'Пароль: ',
    placeholderPhone: 'Введите номер телефона',
    placeholderPassword: 'Введите пароль',
    keepMeSignedIn: 'Оставаться в системе',
    labelSendCode: 'Код подтверждения: ',
    placeholderSendCode: 'Введите код',
    getCodeButton: 'Получить код подтверждения',
    weSentCode: 'Мы выслали SMS с кодом подтверждения\n'
      + 'на Ваш номер телефона',
    sendCodeAgain: 'Выслать код еще раз',
    sendCodeTimer: 'Выслать код подтверждения повторно через ',
    haveAccount: 'У вас уже есть аккаунт?',
    register: 'Зарегистрироваться',
    loginLink: 'Войти',
    userAlreadyExist: 'Пользователь с таким телефоном уже существует',
  },
  restorePasswordForm: {
    description: 'Пожалуйста, введите номер телефона и новый пароль, затем подтвердите кодом из SMS',
    labelPhoneNumber: 'Номер телефона',
    labelPassword: 'Пароль',
    placeholderPhone: 'Введите номер телефона',
    placeholderPassword: 'Введите пароль',
    confirm: 'Подтвердить',
    labelSendCode: 'Код подтверждения',
    placeholderSendCode: 'Введите код',
    getCodeButton: 'Получить код подтверждения',
    weSentCode: 'Мы выслали SMS с кодом подтверждения\n'
      + 'на Ваш номер телефона',
    sendCodeAgain: 'Выслать код еще раз',
    sendCodeTimer: 'Выслать код подтверждения повторно через ',
    changePassword: 'Изменить пароль',
    loginLink: 'Войти',
    or: 'или',
    registrationLink: 'Зарегистрироваться',
  },
};
const faq = {
  faq: {
    title: 'Частые вопросы',
    list: [
      {
        id: 'question-1',
        question: 'Вопрос 1',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-2',
        question: 'Вопрос 2',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-3',
        question: 'Вопрос 3',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-4',
        question: 'Вопрос 4',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-5',
        question: 'Вопрос 5',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-6',
        question: 'Вопрос 6',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-7',
        question: 'Вопрос 7',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-8',
        question: 'Вопрос 8',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-9',
        question: 'Вопрос 9',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-10',
        question: 'Вопрос 10',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-11',
        question: 'Вопрос 11',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-12',
        question: 'Вопрос 12',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-13',
        question: 'Вопрос 13',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-14',
        question: 'Вопрос 14',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
      {
        id: 'question-15',
        question: 'Вопрос 15',
        answer: 'Значимость этих проблем настолько очевидна, что сложившаяся структура организации обеспечивает широкому кругу (специалистов) участие в формировании соответствующий условий активизации. Значимость этих проблем настолько очевидна, что укрепление и развитие структуры позволяет выполнять важные задания по разработке систем массового участия. Не следует, однако забывать, что укрепление и развитие структуры влечет за собой процесс внедрения и модернизации новых предложений.',
      },
    ],
  },
};

export const ru = {
  ...components,
  ...commonPhrases,
  ...forms,
  ...faq,
};
